import { makeStyles } from "@mui/styles";
import { RED_PRIMARY } from "../constants";

const BLUE = "#4A7396";

const useStyles = makeStyles({
  dialogPaper: {
    maxWidth: "calc(96vw * 0.9)",
    width: "calc(96vw * 0.9)",
    "& .MuiDialogContent-root": {
      padding: "0 !important",
    },
  },
  dialogHeader: {
    backgroundColor: "#4A7396",
    color: "white",
    textAlign: "center",
    width: "100%",
  },
  headerTitle: {
    fontSize: "24px",
    fontWeight: "bold",
    fontFamily: "objektiv-mk2, sans-serif",
    textAlign: "center",
  },
  headerSubtitle: {
    fontSize: "16px",
    fontFamily: "objektiv-mk2, sans-serif",
    textAlign: "center",
    "& u": {
      textDecoration: "underline",
    },
  },
  dialogBody: {
    padding: "12px 24px",
    maxHeight: "none",
    overflowY: "visible",
    overflowX: "hidden",
  },
  tableContainer: {
    width: "100%",
    overflowX: "hidden",
    overflowY: "visible",
    border: "1px solid #e5e7eb",
    borderRadius: "6px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontFamily: "objektiv-mk2, sans-serif",
    tableLayout: "fixed",
  },
  tableHeader: {
    backgroundColor: "#f3f4f6",
    "& th": {
      padding: "10px 8px",
      textAlign: "center",
      fontSize: "10px",
      fontWeight: "bold",
      color: "#374151",
      textTransform: "uppercase",
      borderBottom: "2px solid #e5e7eb",
      fontFamily: "objektiv-mk2, sans-serif",
      "& p": {
        margin: 0,
        lineHeight: "1.2",
      },
    },
    "& th.status-th": {
      width: "9%",
    },
    "& th.address-th": {
      width: "14%",
    },
    "& th.property-type-th": {
      width: "10%",
    },
    "& th.list-price-th, & th.sale-price-th": {
      width: "9%",
    },
    "& th.list-sale-date-th": {
      width: "16%",
      minWidth: "104px",
    },
  },
  tableBody: {
    "& td": {
      padding: "10px 8px",
      fontSize: "9.4px",
      color: "#1f2937",
      borderBottom: "1px solid #e5e7eb",
      fontFamily: "objektiv-mk2, sans-serif",
      textAlign: "center",
      verticalAlign: "middle",
      "&.market-table-sale-date-row": {
        minWidth: "104px",
        "& .date-td": {
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          alignItems: "center",
          justifyContent: "center",
          gap: "4px",
          whiteSpace: "nowrap",
        },
      },
      "&.list-price-td, &.sale-price-td": {
        "& div": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "2px",
          "& p": {
            display: "inline",
            margin: 0,
          },
        },
      },
    },
    "& tr:last-child td": {
      borderBottom: "none",
    },
  },
  formRow: {
    backgroundColor: "#f9fafb",
    "& td": {
      padding: "12px 8px",
      verticalAlign: "top",
    },
  },
  oldDataRow: {
    "& td": {
      fontSize: "11.3px",
    },
  },
  formInput: {
    width: "100%",
    border: "1px solid #d1d5db",
    borderRadius: "4px",
    fontSize: "12px",
    fontFamily: "objektiv-mk2, sans-serif",
    textAlign: "center",
    "&:focus": {
      outline: "none",
      borderColor: BLUE,
    },
  },
  formInputError: {
    borderColor: RED_PRIMARY,
    backgroundColor: "#fef2f2",
    "&:focus": {
      borderColor: RED_PRIMARY,
    },
  },
  chipRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    alignItems: "center",
    pointerEvents: "auto",
  },
  chipRowOutlineError: {
    border: `1px solid ${RED_PRIMARY}`,
    borderRadius: "6px",
    padding: "4px",
    backgroundColor: "#fef2f2",
  },
  chip: {
    padding: "2px 8px",
    borderRadius: "4px",
    border: `1px solid ${BLUE}`,
    fontSize: "9px",
    fontFamily: "objektiv-mk2, sans-serif",
    cursor: "pointer",
    background: "white",
    lineHeight: 1.1,
    textAlign: "center",
    position: "relative",
    pointerEvents: "auto",
    minWidth: 90,
    minHeight: "26px",
    boxSizing: "border-box",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": { opacity: 0.9 },
  },
  statusChip: {
    width: "108px",
    minWidth: "108px",
    maxWidth: "108px",
    minHeight: "26px",
    boxSizing: "border-box",
  },
  comingSoonLabel: {
    display: "inline-block",
    lineHeight: 1.1,
  },
  priceWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "2px",
    "& input": {
      border: "1px solid #d1d5db",
      borderRadius: "4px",
      fontSize: "12px",
      width: "100%",
      minWidth: 0,
      textAlign: "center",
    },
  },
  priceWrapperError: {
    "& input": {
      borderColor: RED_PRIMARY,
      backgroundColor: "#fef2f2",
    },
  },
  pricePrefix: {
    fontSize: "9px",
    color: "#374151",
    flexShrink: 0,
  },
  smallInput: {
    width: "100%",
    maxWidth: "44px",
    border: "1px solid #d1d5db",
    borderRadius: "4px",
    fontSize: "12px",
    fontFamily: "objektiv-mk2, sans-serif",
    textAlign: "center",
    "&:focus": { outline: "none", borderColor: BLUE },
  },
  smallInputError: {
    borderColor: `${RED_PRIMARY} !important`,
    backgroundColor: "#fef2f2",
    "&:focus": {
      borderColor: RED_PRIMARY,
    },
  },
  bathRow: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    justifyContent: "center",
    "& input": {
      width: "28px",
      border: "1px solid #d1d5db",
      borderRadius: "4px",
      fontSize: "12px",
      textAlign: "center",
      fontFamily: "objektiv-mk2, sans-serif",
      boxSizing: "border-box",
      "&:focus": { outline: "none", borderColor: BLUE },
    },
  },
  bathRowError: {
    "& input": {
      borderColor: RED_PRIMARY,
      backgroundColor: "#fef2f2",
      "&:focus": { borderColor: RED_PRIMARY },
    },
  },
  optionalButtonsRow: {
    display: "flex",
    justifyContent: "center",
    gap: "16px",
    marginTop: "16px",
    marginBottom: "8px",
    alignItems: "center",
  },
  optionalButton: {
    padding: "0px 16px",
    border: `1px solid ${BLUE}`,
    borderRadius: "4px",
    fontSize: "13px",
    fontFamily: "objektiv-mk2, sans-serif",
    cursor: "pointer",
    background: "white",
    color: "#1f2937",
    "&:hover": { backgroundColor: "#eff6ff" },
  },
  optionalButtonSelected: {
    backgroundColor: "#c7ddf8",
  },
  optionalNote: {
    fontSize: "11px",
    color: RED_PRIMARY,
    fontFamily: "objektiv-mk2, sans-serif",
    lineHeight: 1.4,
    fontWeight: "bold",
    backgroundColor: "#fef2f2",
    border: `1px solid ${RED_PRIMARY}`,
    borderRadius: "6px",
    padding: "8px 10px",
    animation: "$blinkNote 1.2s ease-in-out infinite",
  },
  "@keyframes blinkNote": {
    "0%, 100%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.45,
    },
  },
  validationErrors: {
    fontSize: "11px",
    color: RED_PRIMARY,
    marginTop: "8px",
    fontFamily: "objektiv-mk2, sans-serif",
  },
  addressErrorMsg: {
    fontSize: "10px",
    color: RED_PRIMARY,
    marginTop: "6px",
    lineHeight: 1.25,
    textAlign: "center",
  },
  addressCounter: {
    fontSize: "10px",
    color: "#6b7280",
    marginTop: "2px",
    textAlign: "left",
    width: "100%",
  },
  addressCounterError: {
    color: RED_PRIMARY,
  },
  addressPreviewLabel: {
    fontWeight: "bold",
    display: "block",
    lineHeight: 1.25,
  },
  addressPreviewValue: {
    fontWeight: "bold",
    display: "block",
    lineHeight: 1.35,
    marginTop: "2px",
  },
  addressPreview: {
    fontSize: "10px",
    color: "#4b5563",
    marginTop: "2px",
    textAlign: "left",
    width: "100%",
    wordBreak: "break-word",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  addressField: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: "8px",
    width: "100%",
  },
  addressPart: {
    width: "50%",
    maxWidth: "50%",
    alignSelf: "flex-start",
    minWidth: 0,
    textAlign: "left",
  },
  addressPartWide: {
    width: "100%",
    minWidth: 0,
    textAlign: "left",
  },
  footerButtons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
    borderTop: "1px solid #e5e7eb",
    position: "relative",
  },
  footerButtonsCenter: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
  },
});

export default useStyles;
